import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Alert, Col, FormGroup, Input, Label, Row} from "reactstrap";
import {SUPPLIERS_LIST} from "../SupplierTypeSelect";
import classnames from "classnames";
import SupplierCreateModal from "./SupplierCreateModal";
import {useTranslation} from "react-i18next";
import {sendIntercomMessage} from "../../../utils/intercom";

const SupplierCreateIntegration = props => {
  const { t } = useTranslation('suppliers_modal')
  const [searchText, setSearchText] = useState('')
  const [supplier, setSupplier] = useState(null)
  const [isSaved, setIsSaved] = useState(false)

  const getSuppliersList = () => {
    const searchTextArray = searchText.split(' ')

    return SUPPLIERS_LIST.filter(supplier => {
      if(searchText.length === 0){
        return true
      }

      const supplierName = supplier.value.toLowerCase()

      return searchTextArray.some(text => supplierName.includes(text.toLowerCase()))
    })
  }

  const handleModalClose = () => {
    if (!isSaved && supplier) {
      sendIntercomMessage(t('intercom_help_message', {supplierName: SUPPLIERS_LIST.find(_supplier => _supplier.value === supplier.value)?.name ?? supplier?.value}))
    }
    setSupplier(null);
  };

  const handleSave = () => {
    setIsSaved(true);
    setSupplier(null);
  };

  return (
    <React.Fragment>
      <div className="d-flex flex-row flex-nowrap align-items-center mb-3">
        <Label className="mr-2 mb-0 text-nowrap">{t('integrations_create.label_search')}</Label>
        <Input
          placeholder={t('integrations_create.search_placeholder')}
          onChange={e => setSearchText(e.target.value)}
          value={searchText}
        />
      </div>
      <Row className="supplier-img-list">
        {getSuppliersList().length === 0 && <Alert color="warning" className="text-center w-100">{t('integrations_create.no_results')}</Alert>}
        {getSuppliersList().map((supplier, key) => {
          if(!supplier.importFromApi){
            return null
          }

          return <Col key={key} className="mb-3" xs={6} sm={4} md={3}>
            <div
              className={classnames({
                'supplier rounded py-3 px-1 cursor-pointer border h-100 d-flex align-items-center': true,
              })}
              onClick={() => {
                setSupplier(supplier);
                setIsSaved(false);
              }}
            >
              <img
                className="mx-auto d-block logo-img grayscale"
                src={supplier.logo}
                style={{maxHeight: '45px', maxWidth: '90%'}}
              />
            </div>
          </Col>
        })
        }
      </Row>

      {supplier && <SupplierCreateModal
        supplier={supplier}
        onClose={handleModalClose}
        onSave={handleSave}
      />}
    </React.Fragment>
  );
};

SupplierCreateIntegration.propTypes = {

};

export default SupplierCreateIntegration;